/* tslint:disable:jsx-no-lambda */
import { Button, Checkbox, ComboBox, Modal, TextInput, VALIDATION_STATE } from '@abb/common-ux';
import * as React from 'react';
import { Option } from 'react-select';
import { OptionValues } from '../../../node_modules/@types/react-select';
import { IUser, User } from './models';

import './userModal.scss';

export interface IUserModalState {
  user: IUser;
  countries: Array<Option<OptionValues>>;
  userEmailValidation: VALIDATION_STATE;
  isSaveButtonDisabled: boolean;
  isCreateModal: boolean;
}

export interface IUserModalProps {
  user: IUser;
  isOpen: boolean;
  onClose: () => void;
  onCreate: (user: IUser) => Promise<boolean>;
  onUpdate: (user: IUser) => Promise<boolean>;
  onDelete: () => void;
}

export class UserModal extends React.Component<IUserModalProps, IUserModalState> {
  constructor(props: any) {
    super(props);

    this.state = {
      user: new User(),
      countries: require('./Country.json'),
      userEmailValidation: 'none',
      isSaveButtonDisabled: true,
      isCreateModal: true
    };
  }

  render() {
    const adminOptions = [{ label: 'Admin', value: true }, { label: 'Non-Admin', value: false }];
    const scopeValues = this.state.countries.map((value: any) => {
      const opt = { label: value.countryID, value: value.countryID };
      return opt;
    });

    const modalSubmit = this.state.isCreateModal ? 'Create' : 'Save';
    const deleteUserButton = this.state.isCreateModal ? '' : <Button className='deleteTrashCan' buttonType='discrete' buttonSize='default' id='deleteUser' icon='trash' onClick={this.props.onDelete} />;

    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.handleClose}
        header={this.state.isCreateModal ? 'CREATE USER' : 'EDIT USER'}
        modalClassName='userModal'
        overlayClassName='modalOverlay'
      >
        <div className='modal-body row'>
          <div className='col-md-12'>

            <div className='row form-group'>
              <TextInput
                name='email' labelText='Email' placeholder='Email'
                value={this.state.user.email}
                validationState={this.state.userEmailValidation}
                isRequired={true}
                onChange={this.handleUserFieldChange}
                className='col-md-12' inputSize='small' />
            </div>

            <div className='row'>
              <div className='col-lg-12'>
                <ComboBox
                  labelText='Admin Status'
                  options={adminOptions}
                  value={this.state.user.isAdmin}
                  onChange={this.handleStatusChange}
                  searchable={false}
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-md-12'>
                <ComboBox
                  placeholder='Select Many'
                  labelText='Scopes'
                  options={scopeValues}
                  value={this.state.user.scopes}
                  onChange={this.handleScopeChange}
                  searchable={false}
                  multiSelect={true}
                  disabled={this.state.user.allScopes}
                  size='small' />
              </div>
            </div>

            <div className='row'>
              <div className='col-lg-12'>
                <Checkbox
                  id='allScopesCheck'
                  label='Scope by all countries'
                  checked={this.state.user.allScopes}
                  onChange={this.handleCheckbox}
                />
              </div>
            </div>

          </div>
        </div>

        <div className='modal-footer row form-group noBottomPadding'>
          {deleteUserButton}
          <div style={!this.state.isCreateModal ? { position: 'absolute', right: '33px', bottom: '26px' } : {}}>
            <Button buttonType='discrete' buttonSize='default' id='closeUserModal' onClick={this.handleClose}>Cancel</Button>{' '}
            <Button buttonType='primary' buttonSize='default' id='saveUserBtn' disabled={this.state.isSaveButtonDisabled} onClick={this.state.isCreateModal ? this.handleCreate : this.handleUpdate}>{modalSubmit}</Button>
          </div>
        </div>
      </Modal>

    );
  }

  componentDidMount() {
    this.setState({ user: this.props.user, isCreateModal: this.props.user.email.length === 0 });
  }

  handleCheckbox = (event: any) => {
    const nextUser = { ...this.state.user, allScopes: !this.state.user.allScopes };
    this.setState({ user: nextUser, isSaveButtonDisabled: this.handleSaveButtonDisabled(nextUser, this.state.userEmailValidation) });
  }

  handleSaveButtonDisabled(nextUser: User, userEmailValidation: VALIDATION_STATE) {
    return (nextUser.email === '' || nextUser.email.indexOf(' ') === 0 || userEmailValidation === 'invalid');
  }

  handleStatusChange = (opt: Option) => {
    const nextUser = { ...this.state.user, isAdmin: opt.value as boolean };
    this.setState({ user: nextUser, isSaveButtonDisabled: this.handleSaveButtonDisabled(nextUser, this.state.userEmailValidation) });
  }

  handleUserFieldChange = (event: React.ChangeEvent<any>) => {
    const value = event.target.value;
    const name = event.target.name;
    const newValue = {};
    newValue[name] = value;
    const nextUser = { ...this.state.user, ...newValue};
    if (value.length > 100) {
        this.setState({ user: nextUser, userEmailValidation: 'invalid', isSaveButtonDisabled: true});
    } else if (value.length === 0) {
        this.setState({ user: nextUser, userEmailValidation: 'none', isSaveButtonDisabled: true });
    } else {
        const userEmailValidation: VALIDATION_STATE = 'none';
        this.setState({ user: nextUser, userEmailValidation: 'none', isSaveButtonDisabled: this.handleSaveButtonDisabled(nextUser, userEmailValidation) });
    }
  }

  handleScopeChange = (opts: Option[]) => {
    let selectedScopes: string[] = [];
    opts.forEach( s => {
      selectedScopes =  selectedScopes.concat(s.value as string);
    });
    const nextUser = { ...this.state.user, scopes: selectedScopes};
    this.setState({ user: nextUser, isSaveButtonDisabled: this.handleSaveButtonDisabled(nextUser, this.state.userEmailValidation) });
  }

  handleCreate = async () => {
    this.state.user.scopes = this.state.user.allScopes ? [] : this.state.user.scopes;
    const successful = await this.props.onCreate(this.state.user);
    if (successful) {
      this.handleClose();
    }
  }

  handleUpdate = async () => {
    this.state.user.scopes = this.state.user.allScopes ? [] : this.state.user.scopes;
    const successful = await this.props.onUpdate(this.state.user);
    if (successful) {
      this.handleClose();
    }
  }

  handleClose = () => {
    this.setState({ user: new User(), isSaveButtonDisabled: true, userEmailValidation: 'none' });
    this.props.onClose();
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/userManagement/userModal.tsx